module.exports = __webpack_public_path__ + "media/images/star-4-d6e6de28b185c667a81b7af14740aad6.png";